import React from 'react';
import { CTAButton } from './CTAButton';
export const PricingSection: React.FC = () => {
  return <section id="precio" className="bg-[#FAFAF5] py-[70px] px-5 text-center" data-id="element-188">
      <h2 className="text-[clamp(22px,3.5vw,36px)] text-[#1A1A1A] mb-[30px]" data-id="element-189">
        Elegí tu Mega Pack Tierra Viva
      </h2>

      <div className="grid grid-cols-1 gap-[25px] max-w-[750px] mx-auto" data-id="element-190">
        <div className="bg-white rounded-[20px] py-10 px-[30px] shadow-[0_15px_50px_rgba(255,215,0,0.2)] relative overflow-hidden text-center transition-transform duration-300 hover:-translate-y-1 border-[3px] border-gold-main" data-id="element-191">
          <div className="absolute top-[18px] -right-[28px] bg-gradient-to-r from-gold-main to-gold-dark text-[#1A1A1A] py-1.5 px-[50px] text-[11px] font-sans font-black rotate-45 tracking-[1px]" data-id="element-192">
            MÁS ELEGIDO
          </div>
          <div className="text-[40px] mb-[15px]" data-id="element-193">🌿</div>
          <h3 className="text-xl text-[#1A1A1A] mb-1 font-sans font-bold" data-id="element-194">
            MEGA PACK TIERRA VIVA
          </h3>
          <p className="text-[13px] text-[#888] font-sans mb-5" data-id="element-195">
            3 Tomos + 4 Bonos Pro
          </p>

          <div className="bg-[#F5F0E8] rounded-lg py-2 px-[15px] text-[13px] font-sans text-brown-mid mb-5" data-id="element-196">
            Ideal para: Todo autoconstructor que quiere ir del suelo a la llave
          </div>

          <p className="text-lg text-[#BBB] line-through font-sans mb-1" data-id="element-197">
            $56.000
          </p>
          <div data-id="element-198">
            <span className="text-[24px] text-brown-light align-top mt-3 inline-block" data-id="element-199">
              $
            </span>
            <span className="text-[clamp(44px,7vw,62px)] font-black text-green-brand leading-none mb-1" data-id="element-200">
              19.999
            </span>
          </div>
          <p className="text-sm text-[#999] font-sans mb-[25px]" data-id="element-201">
            ARS · Pago único · Acceso inmediato
          </p>

          <div id="comprar" data-id="element-202">
            <CTAButton href="https://pagos.indigo33.shop/cart/43998649712728:1" className="w-full mb-[15px] !py-4 !px-[30px] !text-base" data-id="element-203">
              → QUIERO MI MEGA PACK
            </CTAButton>
          </div>

          <div className="flex justify-center gap-2 flex-wrap" data-id="element-204">
            <span className="bg-[#F5F5F5] border border-[#E0E0E0] rounded-md py-1 px-3 text-[11px] font-sans text-[#555] font-semibold" data-id="element-205">
              💳 Tarjeta
            </span>
            <span className="bg-[#F5F5F5] border border-[#E0E0E0] rounded-md py-1 px-3 text-[11px] font-sans text-[#555] font-semibold" data-id="element-206">
              📱 MercadoPago
            </span>
            <span className="bg-[#F5F5F5] border border-[#E0E0E0] rounded-md py-1 px-3 text-[11px] font-sans text-[#555] font-semibold" data-id="element-207">
              🏦 Transferencia
            </span>
          </div>
        </div>
      </div>

      <p className="text-[13px] text-[#AAA] font-sans mt-5" data-id="element-208">
        🔒 Pago 100% seguro &nbsp;|&nbsp; ⚡ Acceso en 5 minutos &nbsp;|&nbsp;
        🛡️ Garantía 7 días
      </p>
    </section>;
};